import React from 'react'
import PropTypes from 'prop-types'

import NotificationCountBadge from './NotificationCountBadge'

class NotificationsIndicator extends React.Component {
  static propTypes = {
    theme: PropTypes.oneOf(['dark', 'light']),
    onFetchUnreadCount: PropTypes.func.isRequired,
    realtimeUpLinkFn: PropTypes.func.isRequired,
    onClick: PropTypes.func,
  }
  static defaultProps = {
    theme: 'dark',
  }
  state = {
    unreadInboxCount: undefined,
  }

  componentDidMount() {
    this.props.realtimeUpLinkFn((inboxUpdate) => {
      this.setState({
        unreadInboxCount: inboxUpdate.UnreadNotificationCount,
      })
    })
    this.props.onFetchUnreadCount().then((unreadInboxCount) => this.setState({ unreadInboxCount }))
  }
  render() {
    return (
      <span
        className="notifications-indicator-comp"
        onClick={this.props.onClick}
      >
        <NotificationCountBadge
          unreadInboxCount={this.state.unreadInboxCount}
          theme={this.props.theme}
        />
      </span>
    )
  }
}

export default NotificationsIndicator
